import axios from '@/api/config'

const additionGoodsRelation = {
  addOrUpdateAdditionGoodsRelation (data) {
    return axios.post(`${process.env.BASE_URL}/additionGoodsRelation/addOrUpdateAdditionGoodsRelation` , data)
  },
  getAdditionGoodsRelation (data) {
    return axios.get(`${process.env.BASE_URL}/additionGoodsRelation/getAdditionGoodsRelation` , {params: data})
  },
  addOrUpdateSelectedAdditionGoodsRelation (data) {
    return axios.get(`${process.env.BASE_URL}/selectedAdditionGoodsRelation/addOrUpdateSelectedAdditionGoodsRelation` , {params: data})
  },
  deleteAdditionGoodsRelation (data) {
    return axios.delete(`${process.env.BASE_URL}/additionGoodsRelation/deleteAdditionGoodsRelation` , {data: data})
  },

}

export default additionGoodsRelation



// WEBPACK FOOTER //
// ./src/api/additionGoodsRelation.js